import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";
const MyRequests = React.lazy(() => import("./MyRequests"));
const PendingRequests = React.lazy(() => import("./PendingRequests"));
const ApprovedRequests = React.lazy(() => import("./ApprovedRequests"));
const LeaveRequestDetails = React.lazy(() => import("./LeaveRequestDetails"));
const CreateRequest = React.lazy(() => import("./CreateRequest"));
const ReimburseRequest = React.lazy(() => import("./ReimburseRequest"));
const LeaveLogs = React.lazy(() => import("./LeaveLogs"));
export const LeaveConfigs = [
    {
        permittedRole: [
            RoutePermittedRole.MANAGER,
            // RoutePermittedRole.ADMIN,
            // RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/leave/requests",
        element: <MyRequests />,
    },
    {
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            // RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/leave/pending",
        element: <PendingRequests />,
    },
    {
        permittedRole: [
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ACCOMODATION,
        ],
        path: "/leave/approved",
        element: <ApprovedRequests />,
    },
    {
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/leave/:requestId",
        element: <LeaveRequestDetails />,
    },
    {
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
        ],
        path: "/leave/create-request",
        element: <CreateRequest />,
    },
    {
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
        ],
        path: "/leave/edit-request/:requestId",
        element: <CreateRequest />,
    },
    {
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.MEMBER,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
        ],
        path: "/leave/reimburse-request/:requestId",
        element: <ReimburseRequest />,
    },
    {
        permittedRole: [
            RoutePermittedRole.MANAGER,
            RoutePermittedRole.ADMIN,
            RoutePermittedRole.SUPER_ADMIN,
            RoutePermittedRole.HR_MANAGER,
            RoutePermittedRole.FINANCE_MANAGER,
            RoutePermittedRole.DOCTOR,
            RoutePermittedRole.FRONTDESK,
            RoutePermittedRole.KITCHEN,
            RoutePermittedRole.ACCOMODATION,
            RoutePermittedRole.LOCATION_MANAGER,
            RoutePermittedRole.SETUP_MANAGER,
        ],
        path: "/leave/logs",
        element: <LeaveLogs />,
    },
];
